import { render, staticRenderFns } from "./QuotaMeter.vue?vue&type=template&id=2620682b&scoped=true"
import script from "./QuotaMeter.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotaMeter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QuotaMeter.vue?vue&type=style&index=0&id=2620682b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620682b",
  null
  
)

export default component.exports